export default "__VITE_ASSET__ZhQJ8_EQ__"